import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="page-footer">
      <div className="footer-main">
        <div className="container-title">
          <h4 className='footer-title'>Dr. Luciano Gazzoni</h4>
          <p className='footer-crm'>CRM 8493-DF | RQE 6960</p>
        </div>

        <div className="main-info">
          <div className="left-row">
            <div>
              <h6 className='footer-title-row'>Contato</h6>
              <p className='footer-content'><img src="/images/footer/telephone.png" alt="Ícone telefone" style={{ width: '16px', height: '16px'}}/> (61) 3244-0000</p>
              <p className='footer-content'><img src="/images/footer/telephone.png" alt="Ícone telefone" style={{ width: '16px', height: '16px'}}/> (61) 98625-3859</p>
            </div>
          <br />
            <div>
              <h6 className='footer-title-row'>Horário de Atendimento</h6>
              <p className='footer-content'>8h às 18h</p>
              <p className='footer-content'>De segunda-feira a sexta-feira</p>
            </div>
          <br />
            <div>
              <h6 className='footer-title-row'>Endereço</h6>
                  <p className='footer-content'> BL B - Q 709/909 - Centro Médico Julio Adnet,</p>
                  <p className='footer-content'>Sala 421 - Asa Sul, Brasília</p>
            </div>
            </div>
          </div>

          <div className="middle-row">
            <div>
              <h6 className='footer-title-row'>Navegação</h6>
              <ul className='navigation-list'>
                <li><a href="/tecnologias">Tecnologias</a></li>
                <li><a href="/consultorio">Consultório</a></li>
                <li><a href="/corpo">Cirurgias</a></li>
                <li><a href="/sobre">Sobre</a></li>
                <li><a href="/contato">Contato</a></li>
              </ul>
            </div>
          </div>

            <div className="right-row">
              <h6 className='footer-title-row'>Redes Sociais</h6>
              <ul>
                <li>
                  <a target="_blank" rel="noopener noreferrer" href="https://api.whatsapp.com/send/?phone=5561986253859&type=phone_number&app_absent=0&fbclid=PAZXh0bgNhZW0CMTEAAaZUzbDOUi8Kni3VPyD1ZbM8yarGuhg1c09txIwRHLEQcsWHL2C45h27BeE_aem_pQ027WOUu7yc9ahrdyIJTQ">
                    <img src="/images/footer/whatsapp.png" alt="WhatsApp"/>
                  </a>
                </li>
                <li>
                  <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/dr.lucianogazzoni/">
                    <img  src="/images/footer/instagram.png" alt="Instagram"/>
                  </a>
                </li>
                <li>
                  <a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/@LucianoGazzoni/shorts">
                    <img  src="/images/footer/youtube.png" alt="YouTube"/>
                  </a>
                </li>
                <li>
                  <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/people/Dr-Luciano-Gazzoni-Cirurgi%C3%A3o-Pl%C3%A1stico/61552881904751/">
                    <img  src="/images/footer/facebook.png" alt="Facebook" />
                  </a>
                </li>
              </ul>
            </div>
        </div>

      <div className="copyright">
        <div >
          <span className='copyright-main-text'>Dr. Luciano Gazzoni &copy; {currentYear}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
